import { _CloudArmor } from './cloudArmor';

export namespace Infra {
  export import CloudArmor = _CloudArmor;
}
